import {
  Alert,
  Button,
  Col,
  DesignTokens,
  FullWidthSpace,
  LabeledItem,
  Row,
  Space,
  Table,
  Text,
  Title,
} from "melco-ui";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { useFormikContext } from "formik";
import { DisplayFormErrors, DrawerFooterContent } from "melco-shared-logic";

const Right = styled(Space)`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

const { spacings } = DesignTokens;

type DisplayUpgradeLicenseSummaryProps = {
  stepback: any;
  newValuesToUpgrade: any;
  currentLicense: any;
  licenseFormValues: any;
};

export const DisplayUpgradeLicenseSummary: React.FC<
  DisplayUpgradeLicenseSummaryProps
> = ({ stepback, licenseFormValues, currentLicense, newValuesToUpgrade }) => {
  const { t } = useTranslation();
  const { submitForm } = useFormikContext();

  const columns = [
    {
      title: t("licensemanager.upgrade.table.columns.current"),
      dataIndex: "current",
      //  width: 120,
      render: (value: string) => <Text type="secondary">{value}</Text>,
    },
    {
      title: t("licensemanager.upgrade.table.columns.new"),
      dataIndex: "new",
    },
  ];

  const data = [
    {
      key: "version",
      current: currentLicense.version_number,
      new: newValuesToUpgrade?.new_version_id_display_value,
    },
    {
      key: "level",
      current: currentLicense.subscription_code,
      new: newValuesToUpgrade.new_subscription_code_display_value,
    },
  ];

  return (
    <>
      <div>
        <FullWidthSpace direction="vertical" size="middle">
          <Title level={4}>{t("licensemanager.upgrade.form.summary")}</Title>
          <DisplayFormErrors />
          <Alert
            type="info"
            withBackground
            message={t("licensemanager.upgrade.alert.message")}
          />
          <div>
            <Title level={4}>
              {t("licensemanager.upgrade.form.licensedetails")}
            </Title>

            <Row gutter={[spacings.middle, 0]}>
              <Col xs={24} md={8}>
                <Space direction="vertical" size="middle">
                  <LabeledItem
                    label={t("licensemanager.upgrade.form.melco_customer_id")}
                    content={licenseFormValues.melco_customer_id}
                    fallback={t("licensemanager.upgrade.form.fallback")}
                  />
                  <LabeledItem
                    label={t("licensemanager.upgrade.form.product")}
                    content={currentLicense.product_name}
                    fallback={t("licensemanager.upgrade.form.fallback")}
                  />

                  <LabeledItem
                    label={t("licensemanager.upgrade.form.version")}
                    content={currentLicense.version_number}
                    fallback={t("licensemanager.upgrade.form.fallback")}
                  />

                  {/* <LabeledItem
                    label={t("licensemanager.upgrade.form.level")}
                    content={currentLicense.subscription_code}
                    fallback={t("licensemanager.upgrade.form.fallback")}
                  /> */}
                </Space>
              </Col>
              <Col xs={24} md={8}>
                <Space direction="vertical" size="middle">
                  <LabeledItem
                    label={t("licensemanager.upgrade.form.email")}
                    content={currentLicense.email_address}
                    fallback={t("licensemanager.upgrade.form.fallback")}
                  />
                  <LabeledItem
                    label={t("licensemanager.create.form.dont_assign_license")}
                    content={
                      licenseFormValues?.assign_license
                        ? t("common.yes")
                        : t("common.no")
                    }
                    fallback={t("global.fallback.empty")}
                  />
                  <LabeledItem
                    label={t("licensemanager.upgrade.form.level")}
                    content={currentLicense.subscription_code}
                    fallback={t("licensemanager.upgrade.form.fallback")}
                  />
                </Space>
              </Col>
              <Col xs={24} md={8}>
                <Space direction="vertical" size="middle">
                  <LabeledItem
                    label={t("licensemanager.upgrade.form.serial_number")}
                    content={currentLicense.serial_number}
                    fallback={t("licensemanager.upgrade.form.fallback")}
                  />
                  <LabeledItem
                    label={t("licensemanager.upgrade.form.language")}
                    content={
                      currentLicense.language != ""
                        ? t(`language.${currentLicense.language}` as any)
                        : ""
                    }
                    fallback={t("licensemanager.upgrade.form.fallback")}
                  />
                </Space>
              </Col>
            </Row>
          </div>
          <div>
            <Title level={4}>
              {t("licensemanager.upgrade.form.version&level")}
            </Title>

            <Table
              columns={columns}
              dataSource={data}
              bordered
              pagination={false}
            />
          </div>
        </FullWidthSpace>
        <DrawerFooterContent>
          <Row>
            <Col xs={24} md={12}>
              <Button
                style={{ minWidth: "80px" }}
                key={"back-btn"}
                type="primary"
                onClick={stepback}
              >
                {t("licensemanager.buttons.back")}
              </Button>
            </Col>
            <Col
              style={{ display: "flex", justifyContent: "flex-end" }}
              xs={24}
              md={12}
            >
              <Right>
                <Button
                  style={{ minWidth: "80px" }}
                  key="add-user-button"
                  type="primary"
                  onClick={() => submitForm()}
                >
                  {t("licensemanager.buttons.upgradelicense&sendemail")}
                </Button>
              </Right>
            </Col>
          </Row>
        </DrawerFooterContent>
      </div>
    </>
  );
};
